module.exports = __webpack_public_path__ + "img/syukyaku-kyoutu-maru009.564e8ee2.png";